import { formatDisplayTime } from './formatDisplayTime';
import { getLocalTime } from './getLocalTime';
export var getWorkTime = function getWorkTime(day, timezoneDiff) {
  var callFrom = formatDisplayTime(getLocalTime(day.callFrom, timezoneDiff));
  var callTo = formatDisplayTime(getLocalTime(day.callTo, timezoneDiff));
  return "\u0441 ".concat(callFrom, " \u0434\u043E ").concat(callTo);
};